export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26'),
	() => import('./nodes/27'),
	() => import('./nodes/28'),
	() => import('./nodes/29'),
	() => import('./nodes/30'),
	() => import('./nodes/31'),
	() => import('./nodes/32'),
	() => import('./nodes/33'),
	() => import('./nodes/34'),
	() => import('./nodes/35'),
	() => import('./nodes/36'),
	() => import('./nodes/37'),
	() => import('./nodes/38'),
	() => import('./nodes/39'),
	() => import('./nodes/40'),
	() => import('./nodes/41'),
	() => import('./nodes/42'),
	() => import('./nodes/43'),
	() => import('./nodes/44'),
	() => import('./nodes/45'),
	() => import('./nodes/46'),
	() => import('./nodes/47'),
	() => import('./nodes/48'),
	() => import('./nodes/49'),
	() => import('./nodes/50'),
	() => import('./nodes/51'),
	() => import('./nodes/52'),
	() => import('./nodes/53'),
	() => import('./nodes/54'),
	() => import('./nodes/55'),
	() => import('./nodes/56'),
	() => import('./nodes/57'),
	() => import('./nodes/58'),
	() => import('./nodes/59'),
	() => import('./nodes/60'),
	() => import('./nodes/61'),
	() => import('./nodes/62'),
	() => import('./nodes/63'),
	() => import('./nodes/64'),
	() => import('./nodes/65'),
	() => import('./nodes/66'),
	() => import('./nodes/67'),
	() => import('./nodes/68'),
	() => import('./nodes/69'),
	() => import('./nodes/70'),
	() => import('./nodes/71'),
	() => import('./nodes/72'),
	() => import('./nodes/73'),
	() => import('./nodes/74'),
	() => import('./nodes/75'),
	() => import('./nodes/76'),
	() => import('./nodes/77'),
	() => import('./nodes/78'),
	() => import('./nodes/79'),
	() => import('./nodes/80'),
	() => import('./nodes/81'),
	() => import('./nodes/82'),
	() => import('./nodes/83'),
	() => import('./nodes/84'),
	() => import('./nodes/85'),
	() => import('./nodes/86'),
	() => import('./nodes/87')
];

export const server_loads = [];

export const dictionary = {
		"/": [4],
		"/about": [6],
		"/accident-by-driver": [7],
		"/accident-list": [8],
		"/acord-apps": [9],
		"/acord125": [10],
		"/additional-interest": [11],
		"/agency-admin": [12],
		"/agency-list": [13],
		"/applicant-info": [14],
		"/auto-liability": [15],
		"/auto-physical-damage": [16],
		"/brokerage-coverage": [17],
		"/brokerage-info": [18],
		"/campaign-designer": [19],
		"/campaign-manager": [20],
		"/cargo": [21],
		"/commodities-excess": [22],
		"/commodities-hauled": [23],
		"/commodities-info": [24],
		"/company-contacts": [25],
		"/company-strengths": [26],
		"/contract-owners": [27],
		"/customer": [28],
		"/cyber-security": [29],
		"/dashboard": [30],
		"/deductible-analysis": [31],
		"/driver-info": [32],
		"/drivers-list": [33],
		"/emails": [34],
		"/epic-integrations": [35],
		"/filings": [36],
		"/financials": [37],
		"/fmcsa-accident-analysis": [39],
		"/fmcsa": [38],
		"/freight-forwarding": [40],
		"/fuel-tax": [41],
		"/general-liability": [42],
		"/hired-auto": [43],
		"/import-everything": [44],
		"/import-fuel-tax": [45],
		"/import-loss-runs": [46],
		"/import-mvrs": [47],
		"/import-policy": [48],
		"/insurance-companies": [49],
		"/insurance-history": [50],
		"/landfill-supplemental": [51],
		"/lead-finder": [52],
		"/lienholder": [53],
		"/loss-stratification": [54],
		"/maintenance-info": [55],
		"/market-manager-captives": [56],
		"/market-manager-ic": [57],
		"/market-manager-mga": [58],
		"/mgas": [59],
		"/mileage-rev-pu": [60],
		"/monthly-reporting-exposures": [61],
		"/mvrs": [62],
		"/named-insured": [63],
		"/ncci-modifiers": [64],
		"/non-truckers": [65],
		"/operations-exposure": [66],
		"/operations-info": [67],
		"/payroll-history": [68],
		"/physical-locations": [69],
		"/producer-info": [70],
		"/profile": [71],
		"/public/pay-invoice/[token]": [72,[3]],
		"/public/unsubscribe/[token]": [73],
		"/radius-operations": [74],
		"/report-builder": [75],
		"/safety-info": [76],
		"/safety-materials": [77],
		"/(agency-modules)/sample-module": [5,[2]],
		"/single-cell-captive-analysis": [78],
		"/submission-builder": [79],
		"/system-admin": [80],
		"/tank-wash": [81],
		"/telematics": [82],
		"/trailer-interchange": [83],
		"/umbrella-excess": [84],
		"/vehicles-list": [85],
		"/waste-materials": [86],
		"/workers-comp": [87]
	};

export const hooks = {
	handleError: (({ error }) => { console.error(error) }),
	
	reroute: (() => {}),
	transport: {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));
export const encoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.encode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export { default as root } from '../root.js';